import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

// Layout import
import CenterLayout from '@/components/CenterLayout'
import Layout from '@/components/Layout'

export interface routerType {
  path: string
  component: ReactNode
  children?: routerType[]
}

export const ignorePath = ['/', '/download', '/problem', '/requirement', '/teacher-welfare', '/demo']

const router: routerType[] = [
  {
    path: '/',
    component: <Layout />,
    children: [
      {
        path: '/',
        component: '../pages/home/index.tsx'
      },
      {
        path: '/center',
        component: <CenterLayout />,
        children: [
          {
            path: '/center',
            component: '../pages/center/index.tsx'
          },
          {
            path: '/center/expect',
            component: '../pages/expect/index.tsx'
          },
          {
            path: '/center/lesson-detail',
            component: '../pages/lesson-detail/index.tsx'
          },
          {
            path: '/center/finish-class',
            component: '../pages/finish-class/index.tsx'
          },
          {
            path: '*',
            component: '../pages/center/index.tsx'
          }
        ]
      },
      {
        path: '/download',
        component: '../pages/download/index.tsx'
      },
      {
        path: '/problem',
        component: '../pages/problem/index.tsx'
      },
      {
        path: '/requirement',
        component: '../pages/requirement/index.tsx'
      },
      {
        path: '/teacher-welfare',
        component: '../pages/teacher-welfare/index.tsx'
      },
      {
        path: '*',
        component: '../pages/home/index.tsx'
      }
    ]
  },
  {
    path: '/room',
    component: '../pages/room/index.tsx'
  },
  {
    path: '*',
    component: <Navigate to="/" />
  }
]

export default router
